"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const uuid_1 = require("uuid");
const clsx_1 = __importDefault(require("clsx"));
const MlcPopoverMenu_1 = __importDefault(require("@Components/MlcPopoverMenu"));
const DotsPopover = (props) => {
    const { place } = props;
    const [popoverOpen, setPopoverOpen] = (0, react_1.useState)(false);
    const handleClick = () => {
        setPopoverOpen(!popoverOpen);
    };
    const closePopover = () => {
        setPopoverOpen(false);
    };
    const toolTipId = (0, uuid_1.v4)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MlcPopoverMenu_1.default, { clickableComponent: react_1.default.createElement("div", { className: 'dots' }), menuComponent: props.children, closeMenu: closePopover, classNames: (0, clsx_1.default)('popover-dots-wrapper', popoverOpen && 'hovered'), dataTooltipId: toolTipId, dataTestId: 'dots-popover', handleClick: handleClick, popoverOpen: popoverOpen, place: place })));
};
exports.default = DotsPopover;
